import './index.scss';
import './reactCrop.scss';
import { lang } from '@umu/ukit-lang';
import { Button } from '@umu/umu-design';
import If from 'common/src/components/if';
import { classSet } from '@umu/umu-dom';
import ReactCrop from 'react-image-crop';
import React from 'react';
import {
    IProps,
    OPERATE_TYPE,
    CropHeaderProps,
    SessionImageProps,
    CropToolbarProps,
    CropAreaProps,
    CropButtonsProps,
} from './interface';
import { useImgCropPortal } from './useImgCropPortal';
import { SOURCE_IMG_TYPE } from '../uploadImageAndCrop/interface';

// ==================== 原子化 UI 组件 ====================

/**
 * 裁剪面板标题组件
 */
const CropHeader: React.FC<CropHeaderProps> = ({ title }) => {
    if (!title) {
        return null;
    }
    return <div className="course-crop-portal-heard">{title}</div>;
};

/**
 * 会话图片组件
 */
const SessionImage: React.FC<SessionImageProps> = ({ isSession, imgUrl }) => {
    return (
        <i
            id="imgSessionImg"
            style={{
                alignItems: 'center',
                display: 'none',
                margin: 'auto',
                fontSize: '90px',
                verticalAlign: 'middle',
                textAlign: 'center',
            }}
            className={!isSession ? '' : imgUrl}
        />
    );
};

/**
 * 裁剪工具栏组件
 */
const CropToolbar: React.FC<CropToolbarProps> = ({ onRotate, onZoomIn, onZoomOut }) => {
    return (
        <div className="react-crop-toolbar">
            <i className="crop-toolbar rotate" onClick={onRotate} />
            <i className="crop-toolbar zoom-out" onClick={onZoomOut} />
            <i className="crop-toolbar zoom-in" onClick={onZoomIn} />
        </div>
    );
};

/**
 * 裁剪区域组件
 */
const CropArea: React.FC<CropAreaProps> = ({
    imgUrl,
    crop,
    sourceImgType,
    onImageLoaded,
    onImageError,
    onChange,
    onComplete,
    children,
}) => {
    return (
        <div
            className={classSet({
                'crop-area': true,
                'crop-area-avatar-img': sourceImgType === SOURCE_IMG_TYPE.AVATAR,
            })}
        >
            <ReactCrop
                src={imgUrl}
                crop={crop}
                keepSelection={true}
                onImageLoaded={onImageLoaded}
                onImageError={onImageError}
                onChange={onChange}
                onComplete={onComplete}
            />
            <div className="react-crop-img-micro react-crop-img-micro-background" />
            <div className="react-crop-img-micro react-crop-img-micro-mask" />
            {children}
        </div>
    );
};

/**
 * 裁剪操作按钮组件
 */
const CropButtons: React.FC<CropButtonsProps> = ({ onChangeImg, onCancel, onConfirm }) => {
    return (
        <div className="crop-btn-area">
            <Button type="ghost-grey" onClick={onChangeImg}>
                {lang('更换图片')}
            </Button>
            <div className="operate-img">
                <Button className="operate-img-btn-split" type="ghost-grey" onClick={onCancel}>
                    {lang('取消')}
                </Button>
                <Button onClick={onConfirm} type="primary-blue" className="btn-area btn-submit-area">
                    {lang('确认')}
                </Button>
            </div>
        </div>
    );
};

export const ImgCropPortal = (props: IProps) => {
    const { panelTitle, isShowToolBar = false } = props;

    // 使用自定义 hook 管理所有业务逻辑
    const {
        imgUrl,
        isSession,
        crop,
        onLoadErr,
        onLoad,
        onCropChange,
        onCropComplete,
        confirmHandle,
        onImageToolBar,
        onChangeImg,
        onCancel,
    } = useImgCropPortal(props);

    /**
     * 渲染组件
     */
    const render = () => {
        return (
            <div className="course-crop-portal business-common-course-crop-portal">
                <CropHeader title={panelTitle} />
                <SessionImage isSession={isSession} imgUrl={imgUrl} />

                <If condition={!isSession}>
                    <CropArea
                        imgUrl={imgUrl}
                        crop={crop}
                        sourceImgType={props.sourceImgType}
                        onImageLoaded={onLoad}
                        onImageError={onLoadErr}
                        onChange={onCropChange}
                        onComplete={onCropComplete}
                    >
                        <If condition={isShowToolBar}>
                            <CropToolbar
                                onRotate={() => onImageToolBar(OPERATE_TYPE.ROTATE)}
                                onZoomIn={() => onImageToolBar(OPERATE_TYPE.ZOOM_OUT)}
                                onZoomOut={() => onImageToolBar(OPERATE_TYPE.ZOOM_IN)}
                            />
                        </If>
                    </CropArea>
                </If>

                <CropButtons onChangeImg={onChangeImg} onCancel={onCancel} onConfirm={confirmHandle} />
            </div>
        );
    };

    return render();
};
